import React, { useEffect, useState, useContext } from "react";
import Functions from "../../utility/services/Functions";
import ApiService from "../../utility/services/ApiService";
import { AuthContext } from "../../utility/services/AuthContext";
import { trackScreenView, getUserTrackingParams } from "../../utility/services/analyticsService";

const Hipaa = () => {
  const pageTitle = "HIPAA Compliance Agreement";

  const [htmlContent, setHtmlContent] = useState("");

  const { setLoading, user } = useContext(AuthContext);
  const { consoleService } = Functions();
  const { get_specific_pages_details } = ApiService();

  useEffect(() => {
    trackScreenView("hipaa_screen", { screen_name: "HIPAA", ...getUserTrackingParams(user) });
    get_initial_details();
  }, []);

  async function get_initial_details() {
    try {
      setLoading(true);
      const res = await get_specific_pages_details(pageTitle);
      if (res.status === 1) {
        setHtmlContent(res.data.des);
        setLoading(false);
      } else {
        consoleService("error in get_initial_details fun =- ", res.message);
      }
    } catch (err) {
      consoleService("error in get_initial_details fun = ", err);
    }
  }
  return (
    <>
      <section className="py-5 ">
        <div className="container">
          <div className="row">
            <div className="col-md-12 termHead">
              <h1>HIPAA Compliance Agreement</h1>
            </div>
            <div
              className="col-md-12"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            ></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hipaa;
